__turbopack_context__.v({
  "breadcrumb": "public-page-module__HwEk3W__breadcrumb",
  "card": "public-page-module__HwEk3W__card",
  "cards": "public-page-module__HwEk3W__cards",
  "content": "public-page-module__HwEk3W__content",
  "contents": "public-page-module__HwEk3W__contents",
  "eyebrow": "public-page-module__HwEk3W__eyebrow",
  "hero": "public-page-module__HwEk3W__hero",
  "intro": "public-page-module__HwEk3W__intro",
  "main": "public-page-module__HwEk3W__main",
  "number": "public-page-module__HwEk3W__number",
  "primary": "public-page-module__HwEk3W__primary",
  "related": "public-page-module__HwEk3W__related",
  "section": "public-page-module__HwEk3W__section",
});
